import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-11150f76")

_pushScopeId("data-v-11150f76")
const _hoisted_1 = { class: "header-stepper" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 header-stepper-main" }
const _hoisted_5 = {
  key: 0,
  class: "m-steps"
}
const _hoisted_6 = { class: "stepBackIcon" }
const _hoisted_7 = {
  key: 1,
  class: "m-steps white"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "buttons" }, null, -1)
const _hoisted_9 = { class: "ls-slate" }
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  const _component_HelpScreen = _resolveComponent("HelpScreen")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          (_ctx.navSteps.length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode("span", _hoisted_6, [
                  (_ctx.currentNavStepIndex() > 0 && _ctx.currentNavStepIndex() < 5)
                    ? (_openBlock(), _createBlock("i", {
                        key: 0,
                        class: "fal fa-angle-left",
                        onClick: _cache[1] || (_cache[1] = $event => (_ctx.navigateBack()))
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("ul", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.navSteps, (s) => {
                    return (_openBlock(), _createBlock("li", {
                      onClick: _withModifiers($event => {_ctx.navigate(s);}, ["prevent","stop"]),
                      class: s.status
                    }, _toDisplayString(s.name), 11, ["onClick"]))
                  }), 256))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.navSteps.length === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_7, _toDisplayString(_ctx.navbarText), 1))
            : _createCommentVNode("", true),
          _hoisted_8
        ])
      ])
    ]),
    (_ctx.showHelpScreen)
      ? (_openBlock(), _createBlock(_component_HelpScreen, {
          key: 0,
          onClose: _cache[2] || (_cache[2] = $event => (_ctx.showHelpScreen = false))
        }, {
          header: _withId(() => [
            _createVNode("h3", _hoisted_9, _toDisplayString(_ctx.pageHeader), 1)
          ]),
          body: _withId(() => [
            _createVNode("p", null, _toDisplayString(_ctx.pageDescription), 1),
            _hoisted_10,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pageSection, (s, index) => {
              return (_openBlock(), _createBlock("div", null, [
                _createVNode("h4", null, _toDisplayString(s.sectionHeading), 1),
                _createVNode("p", null, _toDisplayString(s.sectionContent), 1),
                _hoisted_11
              ]))
            }), 256))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
})